export enum PositionKey {
  Tester = "TEST",
  Developer = "DEV",
  ProjectManager = "PM",
  Specialist = "SPEC",
  Sales = "SALES",
}

export type BubblePerson = {
  name: string;
  imageSrc?: string;
  position?: string;
  positionKey: PositionKey;
  bio?: string;
};
export interface FilterTranslation {
  dev: string;
  pm: string;
  qa: string;
  spec: string;
  sales: string;
}

export type BubbleGrid = {
  size: "small" | "big" | "medium";
  onClick?: (key: PositionKey) => void;
  disabled?: boolean;
  backgroundColor?: string;
};

export type BubbleFilter = Omit<BubblePerson, "imageSrc" | "position"> &
  BubbleGrid;

export type Bubble = BubblePerson & BubbleGrid & BubbleFilter;
